import { render } from "./ManageLearningCourseActivity.vue?vue&type=template&id=15f25ded&lang=pug"
import script from "./ManageLearningCourseActivity.vue?vue&type=script&lang=js"
export * from "./ManageLearningCourseActivity.vue?vue&type=script&lang=js"

import "./ManageLearningCourseActivity.vue?vue&type=style&index=0&id=15f25ded&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__